import React from 'react';
import theme from './EndScreen.scss';

class EndScreen extends React.Component {
    componentWillMount() {
        const { onStateChange } = this.props;
        onStateChange(true);
    }

    render() {
        const { header } = this.props;
        return (
            <div className={theme.root}>
                <h2 className="question-heading">{header.title}</h2>
                <div className="question-description">
                    <p>{header.description}</p>
                </div>
            </div>
        );
    }
}

export default EndScreen;



// WEBPACK FOOTER //
// ./src/components/questions/EndScreen.js